import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTheme as useNextTheme } from "next-themes";

type Theme = "light" | "dark" | "system";

export function useTheme() {
  const location = useLocation();
  const { theme, setTheme, resolvedTheme } = useNextTheme();

  // Lista de rotas que NÃO devem ter tema escuro
  const authRoutes = [
    "/login",
    "/register",
    "/2fa",
    "/forgot-password",
    "/reset-password",
  ];
  const isAuthRoute = authRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  // Forçar tema claro para rotas de autenticação
  useEffect(() => {
    if (isAuthRoute) {
      setTheme("light");
    }
  }, [isAuthRoute, setTheme]);

  const toggleTheme = () => {
    setTheme(resolvedTheme === "light" ? "dark" : "light");
  };

  return {
    theme: resolvedTheme as Theme,
    setTheme,
    toggleTheme,
    isDark: resolvedTheme === "dark" && !isAuthRoute,
  };
}
